<template>
  <div class="filter-container">
    <FilterList
      hiddenMyCandidateSwitch
      ref="filterListRef"
      class="talent-pool-list"
      showAISearch
      :candidateList="candidateList"
      :listLoading="listLoading"
      :searchTemplate.sync="searchTemplate"
      :searchTemplateList="searchTemplateList"
      :filterGroupList="filterList"
      :actionList="actionList"
      :aiAnalysisActionList="aiAnalysisActionList"
      :addBtnList="addBtnList"
      :operationList="operationList"
      :candidateTotalCount="candidateTotalCount"
      :currentSelectedCount="currentSelectedCount"
      :currentGroupFilter="currentGroupFilter"
      :isTalentPool="true"
      :hiddenReportChat="hiddenReportChat"
      :hasSoftUserPermission="hasSoftUserPermission"
      :showCandidateTypeSearch="hasEmployeeApplyPermission"
      @add="handleAddAction"
      @selectedChange="handleSelectedChange"
      @selectAll="handleSelectAll"
      @search="handelSearch"
      @scrollBottom="handleScrollBottom"
      @orderChange="handleOrderChange"
      @openDetail="handleOpenDetail"
      @candidateStatusClick="handleCandidateStatusClick"
      @createSearchTemplate="handleCreateSearchTemplate"
      @updateSearchTemplate="handleUpdateSearchTemplate"
      @clearSearchTemplate="handleClearSearchTemplate"
      @deleteSearchTemplate="handleDeleteSearchTemplate"
      @selectAllCard="handleSelectAllCard"
      @searchTalentByActiveness="handleSearchTalentByActiveness"
      @scrollToTop="handleScrollToTop"
      @expandChange="expandChange"
    >
      <template #tableContainer>
        <TableList
          ref="tableContainer"
          :data="candidateList"
          :cancelSelectedCandidateList="cancelSelectedCandidateList"
          :operationList="operationList"
          :loading="listLoading"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
          @candidateStatusClick="handleCandidateStatusClick"
          @openDuplicateCandidateDetail="openDuplicateCandidateDetail"
        ></TableList>
      </template>
      <template #cardContainer>
        <CardList
          ref="cardContainer"
          :data="candidateList"
          :operationList="operationList"
          :loading="listLoading"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
          @candidateStatusClick="handleCandidateStatusClick"
        ></CardList>
      </template>
      <template #filterTip="{filter}">
        <label class="filter-label">{{ filter.label }}</label>
        <i v-auto-tooltip.always="filter.tip" class="filter-tip-icon el-icon-question"></i>
      </template>
    </FilterList>
    <CopyCandidateDialog
      ref="copyCandidateDialog"
      :isTalentPool="true"
      :candidateList="copyCandidateDialog.candidateList"
      :isAllApplication="copyCandidateDialog.isSelectAll"
      :searchParams="searchParams"
    ></CopyCandidateDialog>
    <ExportCandidateAllInfoDialog
      ref="exportCandidateAllInfoDialog"
      isTalentPool
      :exportInfo="exportInfo"
      :isOperator="exportCandidateAllInfoDialog.isOperator"
      @save="saveExportCandidateAllInfo"
      @saveOperator="handleSaveOperatorExportCandidateAllInfo"
    ></ExportCandidateAllInfoDialog>
    <TalentGroupDialog
      ref="talentGroupDialog"
      :isEditor="talentGroupDialog.isEditor"
      :currentGroupFilter="currentGroupFilter"
      @save="saveTalentGroupFilter"
      @update="updateTalentGroupFilter"
    ></TalentGroupDialog>
    <AddCandidateToGroupVue
      ref="addGroupDialog"
      :groupList="groupList"
      :isOperator="addCandidateGroupDialog.isOperator"
      @save="handleSaveCandidateToGroup"
      @saveOperator="handleSaveOperatorCandidateToGroup"
    />
    <MoveGroupDialog
      ref="moveGroupDialog"
      :groupList="groupList"
      :selectedGroupList="groupList"
      :isOperator="moveCandidateGroupDialog.isOperator"
      :i18nTitleKey="'move'"
      @save="handleSaveMovedGroup"
      @saveOperator="handleSaveOperatorMovedGroup"
    ></MoveGroupDialog>
    <MoveGroupDialog
      ref="removedGroupDialog"
      :isRemoved="true"
      :selectedGroupList="groupList"
      :isOperator="removeCandidateGroupDialog.isOperator"
      :i18nTitleKey="'remove'"
      @save="handleSaveRemovedGroup"
      @saveOperator="handleSaveOperatorRemovedGroup"
    ></MoveGroupDialog>
    <AddTagDialog
      ref="addTagDialog"
      :isTalentPool="true"
      :candidateList="addTagDialog.candidateList"
      :isAllApplication="addTagDialog.isSelectAll"
      :searchParams="searchParams"
      @success="reloadListData"
    ></AddTagDialog>
    <AddComment
      ref="addCommentDialog"
      :jobId="commentDialog.jobId"
      :candidateId="commentDialog.candidateId"
      :isTalentPool="true"
    />
    <AIRecommendedSelectJob
      :show.sync="aiRecommendedSelectJobDialog.show"
      :loading="aiRecommendedSelectJobDialog.loading"
      :jobList="aiRecommendedSelectJobDialog.jobList"
      @generateAIRecommendation="handleGenerateAIRecommended"
    ></AIRecommendedSelectJob>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { addI18nProperty, createI18nProperty, getConstantI18nValue, getI18nPropertyValue, isEn } from '@/i18n'
import { DEGREE } from '@/constant/meta'
import { CONSENT_STATUS, GENDER, MUNICIPALITY_CITY, MUNICIPALITY_PROVINCE } from '@/constant/application'
import FilterList from '../applicantList/filterList/layout.vue'
import DateRage from '../applicantList/dateRange.vue'
import RangeSelect from '../applicantList/rangeSelect.vue'
import CopyCandidateDialog from '../applicantList/dialog/copyCandidateDialog.vue'
import AddTagDialog from '../applicantList/dialog/addTagDialog.vue'
import ExportCandidateAllInfoDialog from '../applicantList/dialog/exportCandidateAllInfo.vue'
import TalentGroupDialog from '../applicantList/dialog/talentGroup.vue'
import MoveGroupDialog from '../applicantList/dialog/moveCandidateGroup.vue'
import AddCandidateToGroupVue from '../applicantList/dialog/addCandidateToGroup.vue'
import { AsyncTask } from '@/utils/common'
import CardList from '../application/talentList/card.vue'
import TableList from './filterList/candidateList.vue'
import GroupSelect from '../applicantList/groupSelect.vue'
import JobSelector from '../components/jobSelector.vue'
import AddComment from '@/views/adminNew/candidate/profile/dialog/addComment.vue'
import AIRecommendedSelectJob from './dialog/aiRecommendedSelectJob.vue'
import { AI_EXTRA_PARAMS, COMPANY_LEVEL_ORDER_LIST, CRM_TAG_TYPES, FILTER_GROUP_TYPE, RESUME_SDK_TAG_KEYS, RESUME_SDK_TAG_TYPES } from '@/constant/company'
import WorkCompanyName from '../applicantList/workCompanyName.vue'
import talentApi from '@/api/talent'
import { getFileExtension } from '@/utils/oss'

const CANDIDATE_PREFERENCE_SURVEY = {
  COMPLETED_NO_APPLICATIONS: 'YN',
  COMPLETED_HAS_APPLICATIONS: 'YY'
}

const CANDIDATE_TYPE = {
  EMPLOYEE: 'EMPLOYEE',
  CANDIDATE: 'CANDIDATE'
}

const GRADUATION_YEAR_OPTION_LIST = _.range(moment().year() + 4, 1899, -1)
  .map(year => ({ id: year, i18nName: String(year) }))

const ACTIVENESS = {
  HOT: 'HOT',
  ACTIVE: 'ACTIVE',
  WARM: 'WARM',
  COLD: 'COLD'
  // POTENTIAL: 'POTENTIAL'
}

// const FILTER_GROUP_TYPE = {
//   // APPLICATION_DETAIL: 0,
//   // PROFILE_DETAIL: 1,
//   EMPLOYER: 'employee',
//   JOB_TITLE: 'jobTitle',
//   INDUSTRY: 'industry',
//   SKILL: 'skill',
//   EDUCATION: 'education',
//   CRM_TAG: 'crmTag',
//   PROFILE_DETAIL: 'profileDetail',
//   APPLICATION_DETAIL: 'applicationDetail',
//   CANDIDATE_BEHAVIOR: 'candidateBehavior',
//   CANDIDATE_PREFERENCE: 'candidatePreference',
//   OTHER_FACTOR: 'otherFactor'
// }

const SELECT_ALL_CANDIDATE_LIMIT = {
  EXPORT_PDF: 2000,
  EXPORT_ORIGINAL_RESUME: 2000,
  COPY_CANDIDATE: 2000,
  GROUP: 6000,
  EXPORT_ALL_INFO: 6000,
  ADD_TAG: 20000
}

const TALENT_POOL_PAGE_KEY = 'talent_pool_page_key'

export default {
  components: {
    FilterList,
    CopyCandidateDialog,
    ExportCandidateAllInfoDialog,
    TalentGroupDialog,
    AddCandidateToGroupVue,
    MoveGroupDialog,
    TableList,
    AddTagDialog,
    CardList,
    AddComment,
    AIRecommendedSelectJob
  },
  data () {
    const vm = this
    return {
      i18nPrefix: 'admin.application.applicantList',
      pagination: {
        page: 1,
        pageSize: 20,
        totalPage: 2
      },
      listOrder: {
        prop: 'join_time',
        order: '-'
      },
      searchTemplate: null,
      searchTemplateList: [],
      savedFilterList: [],
      candidateList: [],
      listLoadingCount: 0,
      isSelectedAllCandidate: false,
      isSelectedAllCardCandidate: false,
      selectedCandidateList: [],
      copyCandidateDialog: {
        isSelectAll: false,
        candidateList: []
      },
      exportCandidateAllInfoDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      talentGroupDialog: {
        isSelectAll: false,
        candidateList: [],
        isEditor: false
      },
      addCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      moveCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      removeCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      addTagDialog: {
        isSelectAll: false,
        candidateList: []
      },
      commentDialog: {
        isSelectAll: false,
        candidateId: null
      },
      isSavingSearchTemplate: false,
      location: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      school: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      major: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      workPositionTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      workIndustryTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      crmTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      skillTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      openedTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      sharedTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      appliedTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      openedCampaign: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      sharedCampaign: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      appliedCampaign: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      screenedCampaign: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      interviewedCampaign: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      hiredCampaign: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      candidateTotalCount: 0,
      expectedLocation: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      exportPdfStatus: {
        loading: false,
        task: null,
        finished: false
      },
      searchedGroupList: [],
      searchParams: null,
      searchConfig: null,
      currentGroupFilter: {
        report: {
          total_count: 0,
          new_count: 0,
          items: [
            {
              count: 0,
              name: 'Hot'
            },
            {
              count: 0,
              name: 'Active'
            },
            {
              count: 0,
              name: 'Warm'
            },
            {
              count: 0,
              name: 'Cold'
            },
            {
              count: 0,
              name: 'Potential'
            }
          ]
        }
      },
      exportInfo: {
        loading: false,
        data: [{
          id: 'All',
          get i18nName () {
            return vm.$t('common.label.selectAll')
          },
          children: []
        }]
      },
      tagMap: {},
      groupList: [],
      currentSelectedCount: 0,
      search: {},
      hiddenReportChat: false,
      companyPolicyList: [],
      pageDataLoader: null,
      cancelSelectedCandidateList: [],
      isNoRefreshSelectedCandidateList: false,
      loadResumeSDKTag: null,
      currencyList: [],
      salaryList: [],
      industryList: [],
      aiRecommendedSelectJobDialog: {
        show: false,
        loading: false,
        jobList: []
      },
      metaIndustryList: [],
      metaJobFunctionList: [],
      candidateStatusList: []
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount', 'accountConfig']),
    hasAssessmentPermission () {
      return this.hasAnyPermission('PREMIUM_ASSESSMENTS')
    },
    hasMicrositeCampaignPermission () {
      return this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT')
    },
    hasCRMTagPermission () {
      return this.hasAnyPermission('PREMIUM_TAG_MANAGEMENT')
    },
    hasCRMPreferenceSurveyPermission () {
      return this.hasAnyPermission('PREMIUM_PREFERENCE_SURVEY_MANAGEMENT')
    },
    hasParseResumeTagPermission () {
      return this.hasAnyPermission('PREMIUM_CRM_PARSE_RESUME_SDK_TAG')
    },
    hasCampaignTagPermission () {
      return this.hasMicrositeCampaignPermission && this.hasCRMTagPermission
    },
    hasCopyCandidatePermission () {
      return this.hasAnyPermission(['PREMIUM_COPY_CANDIDATE', 'PERM_HM_APPLY_JOB_FOR_CANDIDATE'])
    },
    hasSoftUserPermission () {
      return this.hasAnyPermission('PREMIUM_SOFT_USER')
    },
    hasEmployeeApplyPermission () {
      return this.hasAnyPermission({
        strict: false,
        any: [
          'PREMIUM_REFERRAL_EMPLOYEE_APPLY_INTERNAL_JOB',
          'COMPUTED_COMPANY_HAS_APPLICATION_OR_EMPLOYEE_PULL_INTEGRATION'
        ]
      })
    },
    hasAITalentRecommendedPermission () {
      return this.hasAnyPermission('PREMIUM_AI_TALENT_RECOMMENDED')
    },
    hasAISearchPermission () {
      return this.hasAnyPermission(['PERM_AI_CHAT_SEARCH', 'PREMIUM_AI_CHAT_SEARCH'])
    },
    hasAICandidateSearchFilterPermission () {
      return this.hasAnyPermission('PREMIUM_AI_CANDIDATE_SEARCH_FILTER')
    },
    currentAccount () {
      return this.getCurrentAccount
    },
    talentFilterGroupId () {
      return this.$route.params.talentFilterGroupId
    },
    activenessType () {
      return this.$route.query.activenessType
    },
    hasCompanyPolicy () {
      return this.companyPolicyList.length > 0
    },
    listLoading: {
      get () {
        return this.listLoadingCount > 0
      },
      set (val) {
        if (val) {
          this.listLoadingCount += 1
        } else {
          this.listLoadingCount -= 1
        }
      }
    },
    actionList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.talentGroup`),
          hasChildren: true,
          hidden: !this.hasCRMTagPermission,
          childrenMenuList: [
            {
              label: this.$t(`${this.i18nPrefix}.btn.action.addTalentGroup`),
              handler: this.handleAddTalentGroupDialog
            },
            {
              label: this.$t(`${this.i18nPrefix}.btn.action.editTalentGroup`),
              handler: this.handleEditTalentGroupDialog,
              hidden: this.currentGroupFilter.is_default || !this.currentGroupFilter.current_user_can_edit
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.group`),
          hasChildren: true,
          childrenMenuList: [
            {
              label: this.$t('admin.application.candidateGroup.title.add'),
              handler: this.openAddGroupDialog
            },
            {
              label: this.$t('admin.application.candidateGroup.title.move'),
              handler: this.openMoveGroupDialog
            },
            {
              label: this.$t('admin.application.candidateGroup.title.remove'),
              handler: this.openRemoveGroupDialog
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
          hasChildren: true,
          childrenMenuList: [
            {
              label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
              handler: this.handleExportCandidateAllInfo
            },
            {
              label: this.$t('admin.application.candidate.btn.exportOriginResume'),
              handler: this.handleExportOriginalResume
            },
            {
              label: this.$t('admin.application.candidate.btn.resume'),
              handler: this.handleExportResume
            },
            {
              label: this.$t('admin.application.candidate.btn.report'),
              hidden: !this.hasAssessmentPermission,
              handler: this.handleExportReport
            },
            {
              label: this.$t('admin.application.candidate.btn.resumeAndReport'),
              hidden: !this.hasAssessmentPermission,
              handler: this.handleExportResumeAndReport
            }
          ]
        }
      ]
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidates`),
          handler: this.handleCopyCandidateAction
        })
      }
      if (this.hasCRMTagPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.addTag`),
          handler: this.handleAddTagDialog
        })
      }
      const filterHiddenActionList = []
      _.forEach(list, action => {
        if (action.hasChildren && !action.hidden) {
          const children = []
          _.forEach(action.childrenMenuList, child => {
            if (!child.hidden) {
              children.push(child)
            }
          })
          action.childrenMenuList = children
          filterHiddenActionList.push(action)
        } else {
          if (!action.hidden) {
            filterHiddenActionList.push(action)
          }
        }
      })
      return filterHiddenActionList
    },
    aiAnalysisActionList () {
      const list = []
      if (this.hasAITalentRecommendedPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.generateAIRecommendation`),
          handler: this.handleTalentPoolAIRecommended
        })
      }
      return list
    },
    addBtnList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.single`),
          childrenMenuList: [
            {
              label: this.$t('admin.application.candidate.label.switchFullResume'),
              handler: this.handleUploadCandidateAction
            },
            {
              label: this.$t('admin.application.candidate.label.switchMiniResume'),
              handler: this.handleUploadCandidateBasicInfoAction
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.batch`),
          handler: this.handleBatchUploadCandidateAction
        }
      ]
      if (!this.hasAnyPermission(['PERM_JOB_CANDIDATE_UPLOAD', 'PREMIUM_CANDIDATE_UPLOAD'])) {
        return []
      }
      return list
    },
    operationList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.group`),
          hasChildren: true,
          childrenMenuList: [
            {
              label: this.$t('admin.application.candidateGroup.title.add'),
              operator: this.openAddGroupDialogOperation
            },
            {
              label: this.$t('admin.application.candidateGroup.title.move'),
              operator: this.openMoveGroupDialogOperation
            },
            {
              label: this.$t('admin.application.candidateGroup.title.remove'),
              operator: this.openRemoveGroupDialogOperation
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
          hasChildren: true,
          childrenMenuList: [
            {
              label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
              operator: this.handleExportCandidateAllInfoOperation
            },
            {
              label: this.$t('admin.application.candidate.btn.exportOriginResume'),
              operator: this.handleExportOriginalResumeOperation
            },
            {
              label: this.$t('admin.application.candidate.btn.resume'),
              operator: this.handleExportResumeOperation
            },
            {
              label: this.$t('admin.application.candidate.btn.report'),
              hidden: !this.hasAssessmentPermission,
              operator: this.handleExportReportOperation
            },
            {
              label: this.$t('admin.application.candidate.btn.resumeAndReport'),
              hidden: !this.hasAssessmentPermission,
              operator: this.handleExportResumeAndReportOperation
            }
          ]
        }
      ]
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidate`),
          operator: this.handleCopyCandidateOperation
        })
      }
      if (this.hasCRMTagPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.addTag`),
          operator: this.handleAddTagOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.addComment`),
        operator: this.handleAddCommentOperation
      })
      return list
    },
    filterList () {
      const vm = this
      const filterConfig = this.accountConfig[TALENT_POOL_PAGE_KEY]?.filterConfig || {}
      const list = {
        [FILTER_GROUP_TYPE.CANDIDATE_TYPE]: {
          title: this.$t(`${this.i18nPrefix}.title.candidateType`),
          filterList: {
            candidateType: {
              hidden: !this.hasEmployeeApplyPermission,
              elType: 'el-select',
              optionValue: 'value',
              optionList: _.map(CANDIDATE_TYPE, (val, key) => createI18nProperty({ value: val }, 'label', `${vm.i18nPrefix}.candidateType.${key}`)),
              setParam: (params, val) => {
                params.candidate_type = val?.value
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EMPLOYER]: {
          title: this.$t(`${this.i18nPrefix}.title.employer`),
          filterList: {
            workCompanyName: {
              elType: WorkCompanyName,
              label: null,
              multiple: true,
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  if (!value) {
                    return
                  }
                  const nameList = _.isArray(value.name) ? value.name : [value.name]
                  return _.map(nameList, name => ({
                    valueKey: name,
                    value: name,
                    detail: `${group.title} - ${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`,
                    summary: `${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`
                  }))
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue.name = null
                filterValue.isLastWork = true
                return filterValue
              },
              setParam: (params, val) => {
                const name = _.isArray(val.name) ? _.join(val.name, ';') : val.name
                if (val.isLastWork) {
                  params.last_work_company_name = name
                } else {
                  params.work_company_name = name
                }
              }
            },
            companyLevelTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.companyLevelTag`),
              label: this.$t(`${this.i18nPrefix}.label.companyLevelTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.COMPANY_LEVEL, true)
                const companyLevel = this.tagMap[RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE][RESUME_SDK_TAG_KEYS.COMPANY_LEVEL]
                return _.orderBy(companyLevel, [item => COMPANY_LEVEL_ORDER_LIST.indexOf(item.cn_name)], ['asc'])
              },
              hidden: !this.hasParseResumeTagPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.company_level_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.JOB_TITLE]: {
          title: this.$t(`${this.i18nPrefix}.title.jobTitle`),
          filterList: {
            lastWorkJobName: {
              elType: 'el-input',
              label: this.$t(`${this.i18nPrefix}.label.lastWorkJobNameSearch`),
              setParam: (params, val) => {
                params.last_work_job_name = val
              }
            },
            workPositionTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.workPositionTag`),
              optionList: this.tagMap[RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE]?.[RESUME_SDK_TAG_KEYS.POSITION],
              hidden: !this.hasParseResumeTagPermission,
              loader: () => {
                return this.initTagList(this.workPositionTag, 'system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.POSITION)
              },
              initData: () => {
                return this.initSelectData(this.workPositionTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.workPositionTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.workPositionTag, filter)
              },
              props: {
                popperClass: 'work-industry-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.workPositionTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.workPositionTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.work_position_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.APPLICATION_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.applicationDetail`),
          filterList: {
            appliedEntity: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.BelongingEntity`),
              loader: this.loadCompanyList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: true,
              optionTooltip: true,
              enableExclude: true,
              style: (company) => {
                return { 'padding-left': `${(company.level || 1) * 15}px` }
              },
              props: {
                popperClass: 'school-popper'
              },
              setParam: (params, val, isExclude) => {
                let paramKey = 'company_ids'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
              }
            },
            appliedJob: {
              elType: JobSelector,
              label: this.$t(`${this.i18nPrefix}.label.appliedJob`),
              multiple: true,
              enableExclude: true,
              props: {
                showSelectAll: true
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey, filterValues) => {
                  if (!value || value.length < 1) {
                    return
                  }
                  let prefix = ''
                  if (filter.enableExclude) {
                    const isExclude = filterValues?._exclude?.includes(filterName)
                    if (isExclude) {
                      prefix = this.$t(`common.conditionType.${filter.multiple ? 'exclude' : 'notEqual'}`)
                    } else {
                      prefix = this.$t(`common.conditionType.${filter.multiple ? 'include' : 'equal'}`)
                    }
                  }
                  return _.map(value, (item, index) => {
                    return {
                      valueKey: item.id,
                      value: item.id,
                      detail: `${group.title} - ${filter.label}: ${prefix} ${item.i18nName}`,
                      summary: `${prefix} ${item.i18nName}`
                    }
                  })
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.id !== value)
                return filterValue
              },
              setParam: (params, val, isExclude) => {
                const jobIds = []
                const jobTypes = []
                _.forEach(val, job => {
                  if (job.type === 'MY_JOB') {
                    jobTypes.push(job.id)
                  } else {
                    jobIds.push(job.id)
                  }
                })
                if (isExclude) {
                  params.job_id__not = jobIds.join(',')
                  params.job_types__not = jobTypes.join(',')
                } else {
                  params.job_id = jobIds.join(',')
                  params.job_types = jobTypes.join(',')
                }
              }
            },
            candidateStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidateStatus`),
              optionList: this.candidateStatusList,
              optionLabel: 'i18nName',
              optionValue: 'key',
              multiple: true,
              optionSearch: true,
              enableExclude: true,
              setParam: (params, val, isExclude) => {
                let paramKey = 'candidate_status'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
              }
            },
            group: {
              elType: GroupSelect,
              label: this.$t(`${this.i18nPrefix}.label.group`),
              props: {
                groupList: this.groupList
              },
              events: {
                saveEditGroup: this.handleSaveEditGroup,
                deleteGroup: this.handleDeleteGroup
              },
              optionValue: 'text',
              multiple: true,
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  if (!value || value.length < 1) {
                    return
                  }
                  return _.map(value, (item, index) => {
                    return {
                      valueKey: index,
                      value: item,
                      detail: `${group.title} - ${filter.label}: ${item.text}`,
                      summary: `${item.text}`
                    }
                  })
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.id !== value.id)
                return filterValue
              },
              setParam: (params, val) => {
                const groups = []
                _.forEach(val, group => {
                  groups.push(group.id)
                })
                params.group_ids = groups.join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.INDUSTRY]: {
          title: this.$t(`${this.i18nPrefix}.title.industry`),
          filterList: {
            workIndustryTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.workIndustryTag`),
              hidden: this.hasAICandidateSearchFilterPermission || !this.hasParseResumeTagPermission,
              loader: () => {
                return this.initTagList(this.workIndustryTag, 'system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.INDUSTRY)
              },
              initData: () => {
                return this.initSelectData(this.workIndustryTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.workIndustryTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.workIndustryTag, filter)
              },
              props: {
                popperClass: 'work-industry-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.workIndustryTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.workIndustryTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.work_industry_tag = _.map(val, 'id').join(',')
              }
            },
            // lastWorkIndustry: {
            //   elType: 'el-select',
            //   label: this.$t(`${this.i18nPrefix}.label.lastWorkIndustry`),
            //   optionList: this.industryList,
            //   optionLabel: 'i18nName',
            //   optionValue: 'id',
            //   multiple: true,
            //   optionSearch: true,
            //   setParam: (params, val) => {
            //     params.last_work_industry = _.map(val, 'id').join(',')
            //   }
            // },
            metaIndustry: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.metaIndustry`),
              hidden: !this.hasAICandidateSearchFilterPermission,
              loader: this.loadMetaIndustryList,
              optionGroup: {
                labelKey: 'i18nName'
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              // labelContainer: {
              //   flex: this.hasAISearchPermission,
              //   showUseAiSwitch: this.hasAISearchPermission
              // }, 暂不需要
              setParam: (params, val) => {
                params.meta_industry_id = _.map(val, 'id').join(',')
              }
            },
            metaJobFunction: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.metaJobFunction`),
              hidden: !this.hasAICandidateSearchFilterPermission,
              loader: this.loadMetaJobFunctionList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              // labelContainer: {
              //   flex: this.hasAISearchPermission,
              //   showUseAiSwitch: this.hasAISearchPermission
              // }, 暂不需要
              setParam: (params, val) => {
                params.meta_job_function_id = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.SKILL]: {
          title: this.$t(`${this.i18nPrefix}.title.skill`),
          filterList: {
            skillTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.skillTag`),
              hidden: !this.hasParseResumeTagPermission,
              loader: this.resetSkillTag,
              optionSearch: (keywords, loadData, valueList) => {
                return this.loadSkillTagList(keywords, valueList)
              },
              loadTemplate: this.loadSkillTagTemplate,
              filterMethod: this.filterSkillTagMethod,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.skillTag, filter)
              },
              selectAll: {
                getOptions: this.getSkillTagSelectAllOptions
              },
              props: {
                collapseTags: true,
                popperClass: 'skill-popper',
                get noDataText () {
                  return vm.getSkillTagNoDataText()
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    this.resetSkillTag(filter)
                  }
                }
              },
              setParam: (params, val) => {
                params.skill_tag = _.map(val, 'id').join(',')
              }
            },
            language: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.language`),
              loader: this.loadLanguageList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              optionSearch: true,
              multiple: true,
              setParam: (params, val) => {
                params.language = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EDUCATION]: {
          title: this.$t(`${this.i18nPrefix}.title.education`),
          filterList: {
            graduateYear: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.graduateYear`),
              optionList: GRADUATION_YEAR_OPTION_LIST,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.graduate_year = _.map(val, 'id').join(',')
              }
            },
            maxDegree: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.maxDegree`),
              optionList: _.map(DEGREE, (val, key) => createI18nProperty({ id: val }, 'i18nName', `meta.DEGREE.${key}`)),
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.max_degree = _.map(val, 'id').join(',')
              }
            },
            school: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.school`),
              loader: this.initSchoolList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: this.loadSchoolList,
              optionTooltip: true,
              loadMore: (filter) => {
                this.loadMoreData(this.school, filter)
              },
              props: {
                popperClass: 'school-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.school)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                params.school_id = _.map(val, 'id').join(',')
              }
            },
            schoolTier: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.schoolTier`),
              label: this.$t(`${this.i18nPrefix}.label.schoolTier`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.EDUCATION, RESUME_SDK_TAG_KEYS.COLLEGE_LEVEL, true)
                return _.reverse(this.tagMap[RESUME_SDK_TAG_TYPES.EDUCATION][RESUME_SDK_TAG_KEYS.COLLEGE_LEVEL])
              },
              hidden: !this.hasParseResumeTagPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              props: { collapseTags: true },
              setParam: (params, val) => {
                params.college_level_tag = _.map(val, 'id').join(',')
              }
            },
            major: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.major`),
              loader: this.initMajorList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.major, keywords, loadData, valueList)
              },
              loadMore: (filter) => {
                this.loadMoreData(this.major, filter)
              },
              props: {
                popperClass: 'major-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.major)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                params.major_ids = _.map(val, 'id').join(',')
              }
            },
            foreignEducationExperience: {
              hidden: !this.hasParseResumeTagPermission,
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.foreignEducationExperience`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.EDUCATION, RESUME_SDK_TAG_KEYS.ABROAD_EDU, true)
                return this.tagMap[RESUME_SDK_TAG_TYPES.EDUCATION][RESUME_SDK_TAG_KEYS.ABROAD_EDU]
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              props: { collapseTags: true },
              setParam: (params, val) => {
                params.abroad_edu_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.PROFILE_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.profileDetail`),
          filterList: {
            workYear: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.workYear`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: _.chain(0).range(16).map(year => {
                  return {
                    label: year >= 15 ? '15+' : year,
                    value: year
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.work_year_min = val[0]
                params.work_year_max = val[1]
              }
            },
            gender: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.gender`),
              multiple: true,
              optionValue: 'value',
              optionList: _.map(GENDER, (val, key) => createI18nProperty({ value: val }, 'label', `${vm.i18nPrefix}.gender.${key}`)),
              setParam: (params, val) => {
                params.gender = _.map(val, 'value').join(',')
              }
            },
            age: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.age`),
              multiple: true,
              props: {
                clearable: true,
                optionList: _.chain(18).range(100).map(age => {
                  return {
                    label: age >= 100 ? '100+' : age,
                    value: age
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.min_age = val[0]
                params.max_age = val[1]
              }
            },
            location: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.location`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              filterMethod: this.filterLocationMethod,
              optionSearch: this.loadLocationList,
              loadTemplate: this.loadLocationTemplate,
              loader: this.getLocationList,
              loadMore: (filter) => {
                this.loadMoreData(this.location, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.location)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.current_country_id = _.map(group.country, 'id').join(',')
                params.current_province_id = _.map(group.district, 'id').join(',')
                params.current_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            expectedLocation: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.expectedLocation`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              optionSearch: this.loadExpectedLocationList,
              loadTemplate: this.loadExpectedLocationTemplate,
              loader: this.getExpectedLocationList,
              loadMore: (filter) => {
                this.loadMoreData(this.expectedLocation, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.expectedLocation)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.expected_country_id = _.map(group.country, 'id').join(',')
                params.expected_province_id = _.map(group.district, 'id').join(',')
                params.expected_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            expectedSalary: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.expectedSalary`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: this.salaryList,
                optionLabelKey: 'name',
                optionValueKey: 'name'
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.salary_min = val[0]
                params.salary_max = val[1]
              }
            },
            joinedStartTimeJoinedEndTime: {
              elType: DateRage,
              label: this.$t(`${this.i18nPrefix}.label.joinedStartTimeJoinedEndTime`),
              multiple: true, // layout组件需要的值
              props: {
                align: 'center',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                disabledFutureDate: true
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.join_start_time = val[0]
                params.join_end_time = val[1]
              }
            },
            consentStatus: {
              elType: 'el-select',
              hidden: !this.hasCompanyPolicy,
              label: this.$t(`${this.i18nPrefix}.label.consentStatus`),
              multiple: true,
              optionList: this.companyPolicyList,
              optionLabel: 'i18nName',
              optionValue: 'value',
              optionSearch: true,
              optionTooltip: true,
              optionGroup: {
                labelKey: 'i18nName',
                valueKey: 'value',
                dataKey: 'status_list'
              },
              props: {
                popperClass: 'consent-info-popper'
              },
              valueDisplay: {
                formatter: this.formatConsentFilterDisplayValue
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.value !== value)
                return filterValue
              },
              setParam: (params, val) => {
                const option = []
                _.forEach(val, policy => {
                  option.push(policy.value)
                })
                params.consent_status = option.join(',')
              }
            },
            hasPhone: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.hasPhone`),
              optionList: [
                { get label () { return vm.$t('common.label.yes') }, value: '1' },
                { get label () { return vm.$t('common.label.no') }, value: '0' }
              ],
              optionLabel: 'label',
              optionValue: 'value',
              setParam: (params, val) => {
                params.has_phone = val.value
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CRM_TAG]: {
          title: this.$t(`${this.i18nPrefix}.title.crmTag`),
          filterList: {
            crmTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.crmTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initCRMTagList(this.crmTag)
              },
              initData: () => {
                return this.initSelectData(this.crmTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.crmTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              enableExclude: true,
              loadMore: (filter) => {
                this.loadMoreData(this.crmTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.crmTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.crmTag, 2)
                  }
                }
              },
              setParam: (params, val, isExclude) => {
                let paramKey = 'tag_id'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
                params.is_match_all_tag = '0'
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR]: {
          title: this.$t(`${this.i18nPrefix}.title.candidateBehavior`),
          filterList: {
            activeness: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.activeness`),
              hidden: !this.hasCRMTagPermission,
              optionValue: 'value',
              multiple: true,
              optionList: _.map(ACTIVENESS, (val, key) => {
                if (key === 'POTENTIAL' && !this.hasSoftUserPermission) {
                  return null
                }
                const option = createI18nProperty({ value: val }, 'label', `${vm.i18nPrefix}.activenessType.${key}`)
                return option
              }).filter(item => item),
              setParam: (params, val) => {
                const activeness = []
                _.forEach(val, option => {
                  activeness.push(option.value)
                })
                params.activeness_type = activeness.join(',')
              }
            },
            openedTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.openedTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initTagList(this.openedTag, 'system', CRM_TAG_TYPES.OPENED)
              },
              initData: () => {
                return this.initSelectData(this.openedTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.openedTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.openedTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'opened-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.openedTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.openedTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_opened_tag = _.map(val, 'id').join(',')
              }
            },
            sharedTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.sharedTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initTagList(this.sharedTag, 'system', CRM_TAG_TYPES.SHARED)
              },
              initData: () => {
                return this.initSelectData(this.sharedTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.sharedTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.sharedTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.sharedTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.sharedTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_shared_tag = _.map(val, 'id').join(',')
              }
            },
            appliedTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.appliedTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initTagList(this.appliedTag, 'system', CRM_TAG_TYPES.APPLIED)
              },
              initData: () => {
                return this.initSelectData(this.appliedTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.appliedTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.appliedTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'opened-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.appliedTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.appliedTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_applied_tag = _.map(val, 'id').join(',')
              }
            },
            openedCampaign: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.openedCampaign`),
              hidden: !this.hasMicrositeCampaignPermission,
              loader: () => {
                return this.initTagList(this.openedCampaign, 'campaign', CRM_TAG_TYPES.OPENED)
              },
              initData: () => {
                return this.initSelectData(this.openedCampaign, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.openedCampaign, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.openedCampaign, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'opened-campaign-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.openedCampaign)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.openedCampaign, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_opened_campaign = _.map(val, 'id').join(',')
              }
            },
            sharedCampaign: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.sharedCampaign`),
              hidden: !this.hasMicrositeCampaignPermission,
              loader: () => {
                return this.initTagList(this.sharedCampaign, 'campaign', CRM_TAG_TYPES.SHARED)
              },
              initData: () => {
                return this.initSelectData(this.sharedCampaign, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.sharedCampaign, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.sharedCampaign, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-campaign-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.sharedCampaign)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.sharedCampaign, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_shared_campaign = _.map(val, 'id').join(',')
              }
            },
            appliedCampaign: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.appliedCampaign`),
              hidden: !this.hasMicrositeCampaignPermission,
              loader: () => {
                return this.initTagList(this.appliedCampaign, 'campaign', CRM_TAG_TYPES.APPLIED)
              },
              initData: () => {
                return this.initSelectData(this.appliedCampaign, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.appliedCampaign, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.appliedCampaign, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'opened-campaign-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.appliedCampaign)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.appliedCampaign, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_applied_campaign = _.map(val, 'id').join(',')
              }
            },
            screenedCampaign: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.screenedCampaign`),
              hidden: !this.hasMicrositeCampaignPermission,
              loader: () => {
                return this.initTagList(this.screenedCampaign, 'campaign', CRM_TAG_TYPES.SCREENED)
              },
              initData: () => {
                return this.initSelectData(this.screenedCampaign, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.screenedCampaign, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.screenedCampaign, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'screened-campaign-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.screenedCampaign)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.screenedCampaign, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_screened_campaign = _.map(val, 'id').join(',')
              }
            },
            interviewCampaign: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.interviewCampaign`),
              hidden: !this.hasMicrositeCampaignPermission,
              loader: () => {
                return this.initTagList(this.interviewedCampaign, 'campaign', CRM_TAG_TYPES.INTERVIEWED)
              },
              initData: () => {
                return this.initSelectData(this.interviewedCampaign, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.interviewedCampaign, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.interviewedCampaign, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'interviewed-campaign-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.interviewedCampaign)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.interviewedCampaign, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_interviewed_campaign = _.map(val, 'id').join(',')
              }
            },
            hiredCampaign: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.hiredCampaign`),
              hidden: !this.hasMicrositeCampaignPermission,
              loader: () => {
                return this.initTagList(this.hiredCampaign, 'campaign', CRM_TAG_TYPES.HIRED)
              },
              initData: () => {
                return this.initSelectData(this.hiredCampaign, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.hiredCampaign, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.hiredCampaign, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'hired-campaign-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.hiredCampaign)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.hiredCampaign, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_hired_campaign = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CANDIDATE_PREFERENCE]: {
          title: this.$t(`${this.i18nPrefix}.title.candidatePreferences`),
          filterList: {
            candidateSurveyQuestions: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidateSurveyQuestions`),
              loader: this.loadCandidateSurveyQuestionList,
              hidden: !this.hasCRMPreferenceSurveyPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              optionGroup: {
                labelKey: 'i18nName',
                dataKey: 'answer'
              },
              setParam: (params, val) => {
                const candidateSurveyQuestions = []
                _.forEach(val, option => {
                  candidateSurveyQuestions.push(`${option.questionId}-${option.id}`)
                })
                params.candidate_survey_questions = candidateSurveyQuestions.join(',')
              }
            },
            employeeSurveyQuestions: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.employeeSurveyQuestions`),
              loader: this.loadEmployeeSurveyQuestionList,
              hidden: !this.hasCRMPreferenceSurveyPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              optionGroup: {
                labelKey: 'i18nName',
                dataKey: 'answer'
              },
              setParam: (params, val) => {
                const employeeSurveyQuestions = []
                _.forEach(val, option => {
                  employeeSurveyQuestions.push(`${option.questionId}-${option.id}`)
                })
                params.employee_survey_questions = employeeSurveyQuestions.join(',')
              }
            },
            candidatePreferenceSurvey: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidatePreferenceSurvey`),
              hidden: !this.hasCRMPreferenceSurveyPermission,
              multiple: true,
              optionValue: 'value',
              optionList: _.map(CANDIDATE_PREFERENCE_SURVEY, (val, key) => {
                return {
                  get label () {
                    return vm.$t(`${vm.i18nPrefix}.candidatePreferenceSurvey.${key}`)
                  },
                  value: val
                }
              }),
              setParam: (params, val) => {
                params.candidate_preference_survey = _.map(val, 'value').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.OTHER_FACTOR]: {
          title: this.$t(`${this.i18nPrefix}.title.otherFactors`),
          filterList: {
            stabilityTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.stabilityTag`),
              label: this.$t(`${this.i18nPrefix}.label.stabilityTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.STABILITY, null, true)
                return _.orderBy(this.tagMap[RESUME_SDK_TAG_TYPES.STABILITY], ['order'], ['asc'])
              },
              hidden: !this.hasParseResumeTagPermission,
              multiple: true,
              optionLabel: 'i18nName',
              optionValue: 'id',
              props: {
                collapseTags: true,
                filterable: true
              },
              setParam: (params, val) => {
                params.stability_tag = _.map(val, item => item.id).join(',')
              }
            },
            riskTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.riskTag`),
              label: this.$t(`${this.i18nPrefix}.label.riskTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.RISKS, null, true)
                return this.tagMap[RESUME_SDK_TAG_TYPES.RISKS]
              },
              hidden: !this.hasParseResumeTagPermission,
              multiple: true,
              optionLabel: 'i18nName',
              optionValue: 'id',
              props: {
                collapseTags: true,
                filterable: true
              },
              enableExclude: true,
              defaultExclude: true,
              setParam: (params, val, isExclude) => {
                let paramKey = 'risks_tag'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, item => item.id).join(',')
              }
            }
          }
        }
      }
      _.forEach(list, (value, key) => {
        value.defaultExpand = filterConfig[key] || false
      })
      return list
    },
    candidateListLength () {
      return this.candidateList.length
    },
    selectAllIsIndeterminate () {
      if (this.currentSelectedCount && (this.currentSelectedCount !== this.candidateTotalCount)) {
        return true
      }
      return false
    }
  },
  created () {
    this.$eventBus.$emit('showLoading', true)
    this.pageDataLoader = this.initPageData()
  },
  mounted () {
    this.pageDataLoader.finally(() => {
      this.$eventBus.$emit('showLoading', false)
      this.listLoading = true
    }).then(() => {
      if (this.hiddenReportChat) {
        return
      }
      const searchTemplate = { search: this.currentGroupFilter.filter_config }
      const candidateBehaviorFilter = searchTemplate.search[FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR]
      if (this.activenessType) {
        if (!candidateBehaviorFilter) {
          this.$set(searchTemplate.search, FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR, {})
        }
        searchTemplate.search[FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR].activeness = [this.activenessType.toUpperCase()]
      }
      return this.$refs.filterListRef.resetSearch(searchTemplate, true)
    }).then((search) => {
      if (this.$refs.filterListRef) {
        this.$refs.filterListRef.noTriggerSearch = false
      }
      return this.handelSearch(search || this.search)
    }).finally(() => {
      this.listLoading = false
    })
  },
  methods: {
    ...mapActions('worldLocation', ['getWorldLocationList']),
    ...mapActions('application', [
      'getLanguageList',
      'getMajorList',
      'getSchoolList',
      'getGroupList',
      'createGroup',
      'updateGroup',
      'deleteGroup',
      'moveCandidateGroup',
      'removeCandidateFromGroup',
      'getSalaryList',
      'getIndustryList',
      'exportOriginalResume'
    ]),
    ...mapActions('company', ['getCompanyGroupedJobList', 'getCompanyChildrenTree', 'getCompanyJobList']),
    ...mapActions('account', [
      'getAccountPageConfigList',
      'createAccountPageConfig',
      'updateAccountPageConfig',
      'deleteAccountPageConfig',
      'setAccountConfig'
    ]),
    ...mapActions('survey', ['getCompanySurveyQuestionList']),
    ...mapActions('agreement', ['getCompanyPolicyItemList']),
    ...mapActions('talent', [
      'getCompanyTalentCandidateList',
      'getTalentFilterGroup',
      'createTalentFilterGroup',
      'updateTalentFilterGroup',
      'createTalentCandidateExportExcelInfoTask',
      'exportTalentCandidateProfilePdf',
      'getExportTalentCandidateProfilePdfTaskStatus',
      'getTalentCandidateExportExcelFieldInfo'
    ]),
    ...mapActions('crm', ['searchTag']),
    ...mapActions('metaInfo', ['getMetaIndustryList', 'getMetaJobFunctionList']),
    ...mapActions('candidateStatus', ['getCandidateStatusList']),
    initPageData () {
      let loaded = null
      const promise = new Promise((resolve) => {
        loaded = resolve
      })
      this.$eventBus.$on('jobSelectorLoaded', () => {
        loaded()
      })
      return Promise.all([
        promise,
        this.loadGroupList(true),
        this.loadSearchTemplateList(),
        this.loadTalentFilterGroup(),
        this.loadCompanyPolicyList(),
        this.loadSalaryList(),
        this.loadIndustryList(),
        this.loadCandidateStatusList()
      ])
    },
    formatRangeFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValue = {
        valueKey: -1,
        value: null,
        summary: null,
        get detail () {
          return `${group.title} - ${this.summary}`
        }
      }
      const startVal = value[0]
      const endVal = value[1]
      const nilVal = [null, undefined, '']
      if (!nilVal.includes(startVal) && !nilVal.includes(endVal)) {
        displayValue.valueKey = -1
        displayValue.value = value
        displayValue.summary = `${filter.label}: ${startVal} ~ ${endVal}`
      } else if (!nilVal.includes(startVal)) {
        displayValue.valueKey = 0
        displayValue.value = value
        displayValue.summary = `${filter.label}: > ${startVal}`
      } else if (!nilVal.includes(endVal)) {
        displayValue.valueKey = 1
        displayValue.value = value
        displayValue.summary = `${filter.label}: < ${endVal}`
      }
      return displayValue
    },
    cancelRangeFilterValue (filterValue, value, valueKey) {
      if (valueKey < 0) {
        return []
      } else {
        return _.map(filterValue, (val, index) => valueKey === index ? null : val)
      }
    },
    formatConsentFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValueList = []
      _.forEach(value, option => {
        const displayValue = {
          valueKey: null,
          value: option.value,
          summary: null,
          detail: null
        }
        const optionValue = option.value + ''
        const policyItemId = parseInt(optionValue.split('-')[0])
        const policyItem = _.find(this.companyPolicyList, policy => policy.id === policyItemId)
        displayValue.summary = option.i18nName
        displayValue.detail = `${group.title}-${policyItem.i18nName}`
        displayValueList.push(displayValue)
      })
      return displayValueList
    },
    handleExportCandidateAllInfo () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.exportCandidateAllInfoDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateList: candidates
      }
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ALL_INFO || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ALL_INFO)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ALL_INFO }))
        return
      }
      this.loadExportAllInfoFields()
      this.$refs.exportCandidateAllInfoDialog.showDialog()
    },
    async saveExportCandidateAllInfo (optionInfo, callback) {
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      const params = {
        info_fields: optionInfo,
        select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidate_ids: candidates,
        search_params: this.searchParams
      }
      let resp = null
      try {
        resp = await this.createTalentCandidateExportExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    handleAddTalentGroupDialog () {
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.talentGroupDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateList: candidates
      }
      this.$refs.talentGroupDialog.showDialog()
    },
    handleEditTalentGroupDialog () {
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.talentGroupDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateList: candidates,
        isEditor: true
      }
      this.$refs.talentGroupDialog.showDialog()
    },
    async loadTalentFilterGroup () {
      if (this.talentFilterGroupId) {
        const resp = await this.getTalentFilterGroup({ groupId: this.talentFilterGroupId })
        if (resp) {
          this.currentGroupFilter = resp
        } else {
          this.hiddenReportChat = true
        }
      }
    },
    async saveTalentGroupFilter (groupInfo, callback) {
      let resp = null
      const filters = {
        filter_config: this.searchConfig,
        search_params: this.searchParams
      }
      try {
        const params = {
          group_name: groupInfo.groupName,
          is_public: groupInfo.is_public,
          parent_group_id: groupInfo.parentGroup,
          filters: filters,
          owner_info: groupInfo.ownerInfo
        }
        resp = await this.createTalentFilterGroup(params)
      } finally {
        callback(resp)
      }
    },
    async updateTalentGroupFilter (groupInfo, callback) {
      let resp = null
      const filters = {
        filter_config: this.searchConfig,
        search_params: this.searchParams
      }
      try {
        const params = {
          group_id: this.talentFilterGroupId,
          group_name: groupInfo.groupName,
          is_public: groupInfo.is_public,
          parent_group_id: groupInfo.parentGroup,
          filters: filters,
          owner_info: groupInfo.ownerInfo
        }
        resp = await this.updateTalentFilterGroup(params)
        if (resp) {
          this.currentGroupFilter = resp
        }
      } finally {
        callback(resp)
      }
    },
    async handleSaveEditGroup (groupInfo, callback) {
      const groupId = groupInfo.id
      let resp = null
      if (!groupId || groupId === -1) {
        return
      }
      try {
        const params = {
          group_id: groupId,
          text: groupInfo.text
        }
        resp = await this.updateGroup(params)
      } finally {
        this.loadGroupList()
        callback(resp)
        const search = this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL]
        let filters = []
        if (search && search.group) {
          filters = search.group
          if (filters.length > 0) {
            _.forEach(filters, group => {
              if (group.id === groupId) {
                group.text = groupInfo.text
              }
            })
            this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = filters
          }
        }
      }
    },
    async handleDeleteGroup (groupInfo) {
      const groupId = groupInfo.id
      if (!groupId || groupId === -1) {
        return
      }
      const params = {
        group_id: groupId
      }

      const resp = await this.deleteGroup(params)
      if (resp) {
        this.loadGroupList()
        this.$message({
          message: this.$t(`${this.i18nPrefix}.message.deleteGroupSuccess`),
          type: 'success'
        })
        const search = this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL]
        let filters = []
        if (search && search.group) {
          filters = search.group
          if (filters.length > 0) {
            this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = _.filter(filters, group => group.id !== groupId)
          }
        }
      }
    },
    async handleSaveMovedGroup (groupInfo, callback) {
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      let resp = null
      try {
        resp = await this.moveCandidateGroup({
          candidate_ids: candidates,
          from_group_id: groupInfo.from,
          to_group: groupInfo.to,
          comment: groupInfo.comment,
          remove_bound_group: false,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
      } finally {
        this.loadGroupList()
        callback(resp)
        this.reloadListData()
      }
    },
    async handleSaveRemovedGroup (groupInfo, callback) {
      const groupId = groupInfo.from
      const comment = groupInfo.comment
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      let resp = null
      try {
        resp = await this.removeCandidateFromGroup({
          candidate_list: candidates,
          group_id: groupId,
          comment: comment,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
      } finally {
        this.loadGroupList()
        callback(resp)
        this.reloadListData()
      }
    },
    async handleSaveCandidateToGroup (groupInfo, callback) {
      const groupId = groupInfo.id
      let resp = null
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      try {
        const params = {
          group_id: groupId,
          text: groupInfo.text,
          candidate_list: candidates,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        }
        resp = await this.createGroup(params)
      } finally {
        this.loadGroupList()
        callback(resp)
        this.reloadListData()
      }
    },
    async handleSearchTalentByActiveness (activeness) {
      if (activeness) {
        if (activeness === 'Potential') {
          this.$router.push({ path: `/v-admin/talent-pool/${this.talentFilterGroupId}/potential/list` })
          return
        }
        const search = this.$refs.filterListRef.formatSearch(this.search)
        const candidateBehaviorFilter = search[FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR]
        if (!candidateBehaviorFilter) {
          this.$set(search, FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR, {})
        }
        search[FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR].activeness = [activeness.toUpperCase()]
        const searchTemplate = {
          search: search
        }
        await this.$refs.filterListRef.resetSearch(searchTemplate)
      }
    },
    handleSearchCandidateByGroup (groupInfo) {
      const search = this.$refs.filterListRef.search
      search[1].group = _.map(groupInfo, item => item.id)
      this.$refs.filterListRef.resetSearch({ search })
    },
    openAddGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.GROUP || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.GROUP)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.GROUP }))
        return
      }
      this.loadGroupList()
      this.$refs.addGroupDialog.openDialog()
    },
    openMoveGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.GROUP || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.GROUP)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.GROUP }))
        return
      }
      this.loadGroupList()
      this.$refs.moveGroupDialog.openDialog()
    },
    openRemoveGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.GROUP || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.GROUP)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.GROUP }))
        return
      }
      this.loadGroupList()
      this.$refs.removedGroupDialog.openDialog()
    },
    handleExportResume () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(true, '0')
    },
    async handleExportOriginalResume () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const selectAllCandidate = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      const candidateIds = _.map(this.selectedCandidateList, 'candidate.id')
      if (!candidateIds.length) {
        this.$message.warning(this.$t('common.label.noData'))
        return
      }
      if (candidateIds.length > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME || (selectAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME }))
        return
      }

      if (candidateIds.length === 1) {
        // 单个导出: 直接下载
        await this.downloadSingleOriginalResume(this.selectedCandidateList[0])
      } else {
        // 批量导出: 调用后端 API，打包发邮件
        await this.exportBatchOriginalResume(candidateIds)
      }
    },
    handleExportReport () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(false, '1')
    },
    handleExportResumeAndReport () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(true, '1')
    },
    async exportPDF (showBaseInfo, profileType) {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      const exportCandidates = []
      _.forEach(this.selectedCandidateList, candidate => {
        exportCandidates.push(candidate.candidate.id)
      })
      if (exportCandidates.length > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_PDF || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_PDF)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.EXPORT_PDF }))
        exportPdfStatus.loading = false
        return
      }
      if (exportCandidates.length === 1) {
        exportPdfStatus.task = new AsyncTask(() => this.exportTalentCandidateProfilePdf({
          candidate_ids: exportCandidates,
          show_base_info: showBaseInfo,
          profile_type: profileType,
          select_all_candidate: false,
          search_params: this.searchParams
        }), (taskId) => this.getExportTalentCandidateProfilePdfTaskStatus({
          task_id: taskId
        }), (taskId) => {
          window.location.href = this.$DjangoBaseUrl(`/django_rest/company/talent-pool/candidate/export-pdf/?task_id=${taskId}&download=1`)
          exportPdfStatus.loading = false
          exportPdfStatus.finished = false
          exportPdfStatus.task = null
        })
      } else {
        const resp = await this.exportTalentCandidateProfilePdf({
          candidate_ids: exportCandidates,
          show_base_info: showBaseInfo,
          profile_type: profileType,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        if (resp) {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
            showClose: true,
            duration: 10 * 1000 // 10s
          })
          exportPdfStatus.loading = false
          exportPdfStatus.finished = false
          exportPdfStatus.task = null
        }
      }
    },
    handleSelectedChange (val) {
      this.selectedCandidateList = val
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      if (val.length !== this.candidateList.length) {
        this.isSelectedAllCardCandidate = false
        this.isSelectedAllCandidate = false
        this.isClickSelectAll = false
      }
      if (this.isSelectedAllCandidate && this.isSelectedAllCardCandidate) {
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
      } else if (this.isSelectedAllCandidate || this.isSelectedAllCardCandidate) {
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateList.length - cancelSelectCount
      } else if (this.isClickSelectAll) {
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateTotalCount - cancelSelectCount
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
      } else {
        this.currentSelectedCount = val.length
        this.isNoRefreshSelectedCandidateList = true
      }
      const cancelCandidateIds = _.map(this.cancelSelectedCandidateList, candidate => candidate.candidate.id)
      this.searchParams.cancel_candidate_ids = cancelCandidateIds.join(',')
    },
    handleSelectAllCard (selected) {
      if (selected) {
        const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
        _.forEach(this.candidateList, candidate => {
          if (!candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          }
        })
        this.isSelectedAllCandidate = true
        this.isSelectedAllCardCandidate = true
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
        this.isClickSelectAll = true
        this.isNoRefreshSelectedCandidateList = false
      } else {
        _.forEach(this.candidateList, candidate => {
          candidate.selected = false
        })
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.currentSelectedCount = 0
        this.isClickSelectAll = false
      }
      this.cancelSelectedCandidateList = []
    },
    handleSelectAll (selected) {
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      this.isSelectedAllCandidate = selected.length > 0
      this.isClickSelectAll = selected.length > 0
      this.isNoRefreshSelectedCandidateList = !this.isSelectedAllCandidate
      this.currentSelectedCount = this.isSelectedAllCandidate ? this.candidateTotalCount - hiddenCandidateList.length : 0
      this.cancelSelectedCandidateList = []
    },
    handleAddAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/-1/add?back=${back}&is_basic_info=0`)
    },
    handleUploadCandidateBasicInfoAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/-1/add?back=${back}&is_basic_info=1`)
    },
    handleUploadCandidateAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/-1/add?back=${back}&is_basic_info=0`)
    },
    handleBatchUploadCandidateAction () {
      window.open(`/v-admin/application/-1/batch-upload/uploader?talent_pool=${this.talentFilterGroupId}`)
    },
    hasSelected () {
      if (!this.isSelectedAllCandidate && this.selectedCandidateList.length < 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAtLeastCandidate`))
        return false
      }
      return true
    },
    handleCopyCandidateAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.copyCandidateDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateList: candidates
      }
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.COPY_CANDIDATE || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.COPY_CANDIDATE)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.COPY_CANDIDATE }))
        return
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleAddTagDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.addTagDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateList: candidates
      }
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG }))
        return
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleAddTagOperation (rowData) {
      this.addTagDialog = {
        isSelectAll: false,
        candidateList: [rowData.candidate.id]
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleExportCandidateAllInfoOperation (rowData) {
      this.exportCandidateAllInfoDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadExportAllInfoFields()
      this.$refs.exportCandidateAllInfoDialog.showDialog()
    },
    async handleSaveOperatorExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        info_fields: optionInfo,
        select_all_candidate: false,
        candidate_ids: this.exportCandidateAllInfoDialog.candidateList,
        search_params: this.searchParams
      }
      let resp = null
      try {
        resp = await this.createTalentCandidateExportExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    openAddGroupDialogOperation (rowData) {
      this.addCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.addGroupDialog.openDialog()
    },
    async handleSaveOperatorCandidateToGroup (groupInfo, callback) {
      const groupId = groupInfo.id
      let resp = null
      try {
        const params = {
          group_id: groupId,
          text: groupInfo.text,
          candidate_list: this.addCandidateGroupDialog.candidateList,
          select_all_candidate: false,
          search_params: this.searchParams
        }
        resp = await this.createGroup(params)
      } finally {
        this.loadGroupList()
        callback(resp)
      }
    },
    openMoveGroupDialogOperation (rowData) {
      this.moveCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.moveGroupDialog.openDialog()
    },
    async handleSaveOperatorMovedGroup (groupInfo, callback) {
      let resp = null
      try {
        resp = await this.moveCandidateGroup({
          candidate_ids: this.moveCandidateGroupDialog.candidateList,
          from_group_id: groupInfo.from,
          to_group: groupInfo.to,
          comment: groupInfo.comment,
          remove_bound_group: false,
          select_all_candidate: false,
          search_params: this.searchParams
        })
      } finally {
        this.loadGroupList()
        callback(resp)
      }
    },
    openRemoveGroupDialogOperation (rowData) {
      this.removeCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.removedGroupDialog.openDialog()
    },
    async handleSaveOperatorRemovedGroup (groupInfo, callback) {
      const groupId = groupInfo.from
      const comment = groupInfo.comment
      let resp = null
      try {
        resp = await this.removeCandidateFromGroup({
          candidate_list: this.removeCandidateGroupDialog.candidateList,
          group_id: groupId,
          comment: comment,
          select_all_candidate: false,
          search_params: this.searchParams
        })
      } finally {
        this.loadGroupList()
        callback(resp)
      }
    },
    handleExportResumeOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, true, '0')
    },
    async handleExportOriginalResumeOperation (rowData) {
      await this.downloadSingleOriginalResume(rowData)
    },
    handleExportReportOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, false, '1')
    },
    handleExportResumeAndReportOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, true, '1')
    },
    async exportSignalPDF (candidateId, showBaseInfo, profileType) {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      exportPdfStatus.task = new AsyncTask(() => this.exportTalentCandidateProfilePdf({
        candidate_ids: [candidateId],
        show_base_info: showBaseInfo,
        profile_type: profileType
      }), (taskId) => this.getExportTalentCandidateProfilePdfTaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/talent-pool/candidate/export-pdf/?task_id=${taskId}&download=1`)
        exportPdfStatus.loading = false
        exportPdfStatus.finished = false
        exportPdfStatus.task = null
      })
    },
    async downloadSingleOriginalResume (rowData) {
      if (!rowData.candidate.resume_path) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.noOriginalResume`))
        return
      }
      try {
        this.$eventBus.$emit('showLoading', true)
        if (!rowData || rowData.is_agency_uploaded_and_hid || !rowData.candidate || !rowData.candidate.id) {
          this.$message.error(this.$t('common.message.downloadFailed'))
          return
        }

        const fileName = `${rowData.candidate.name}_${rowData.candidate.id}_${moment().format('YYYYMMDD')}`
        const ext = getFileExtension(rowData.candidate.resume_path)
        const downloadFileName = ext ? `${fileName}.${ext}` : fileName
        const result = await talentApi.getResumeDownloadUrl(rowData.candidate.id, { file_name: downloadFileName })
        if (!result || !result.url) {
          this.$message.error(this.$t('common.message.downloadFailed'))
          return
        }

        window.location.href = result.url
      } catch (error) {
        this.$message.error(this.$t('common.message.downloadFailed'))
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async exportBatchOriginalResume (candidateIds) {
      try {
        const selectAllCandidate = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
        const resp = await this.exportOriginalResume({
          select_all_candidate: selectAllCandidate,
          select_all_application: false,
          search_params: this.searchParams,
          candidate_ids: candidateIds
        })

        if (resp && resp.task_id) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.exportOriginalResumeTaskCreated`))
        }
      } catch (error) {
        this.$message.error(this.$t('common.message.exportFailed'))
      }
    },
    handleCopyCandidateOperation (rowData) {
      this.copyCandidateDialog = {
        isSelectAll: false,
        candidateList: [rowData.candidate.id]
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleAddCommentOperation (rowData) {
      this.commentDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateId: rowData.candidate.id
      }
      this.$refs.addCommentDialog.openDialog()
    },
    handleLastedWorkChange () {
      const params = this.parseSearchToParams(this.search)
      if (params.work_company_name || params.last_work_company_name) {
        this.handelSearch()
      }
    },
    formatCompanyData (data, company, companyList) {
      addI18nProperty(company, 'i18nName', 'cn_name', 'name')
      companyList.push(company)
      const allChildren = data.children
      const children = allChildren[company.id]
      if (children && children.length > 0) {
        for (const child of children) {
          this.formatCompanyData(data, child, companyList)
        }
      }
      return companyList
    },
    async loadCompanyList () {
      if (!this.companyListLoader) {
        this.companyListLoader = this.getCompanyChildrenTree().then(resp => {
          const currentCompany = {
            id: resp.self.id,
            name: resp.self.name,
            cn_name: resp.self.cn_name,
            level: resp.self.level
          }
          this.company = currentCompany
          const companyList = []
          this.companyList = this.formatCompanyData(resp, currentCompany, companyList)
        })
      }
      await this.companyListLoader
      return this.companyList
    },
    async loadMetaIndustryList () {
      if (!this.metaIndustryListLoader) {
        this.metaIndustryListLoader = this.getMetaIndustryList().then(resp => {
          if (resp) {
            const industryList = []
            const childrenMap = {}
            _.forEach(resp, (industry) => {
              industry.searchTextList = [industry.cn_name, industry.name]
              addI18nProperty(industry, 'i18nName', 'cn_name', 'name')
              if (industry.parent_id) {
                const children = childrenMap[industry.parent_id]
                if (children) {
                  children.push(industry)
                } else {
                  childrenMap[industry.parent_id] = [industry]
                }
              } else {
                if (!childrenMap[industry.id]) {
                  childrenMap[industry.id] = []
                }
                industry.children = childrenMap[industry.id]
                industryList.push(industry)
              }
              this.metaIndustryList = this.orderTagList(industryList)
            })
          }
        })
      }
      await this.metaIndustryListLoader
      return this.metaIndustryList
    },
    async loadMetaJobFunctionList () {
      if (!this.metaJobFunctionListLoader) {
        this.metaJobFunctionListLoader = this.getMetaJobFunctionList().then(resp => {
          if (resp) {
            const jobFunctionList = _.map(resp, jobFunction => {
              jobFunction.searchTextList = [jobFunction.cn_name, jobFunction.name]
              return addI18nProperty(jobFunction, 'i18nName', 'cn_name', 'name')
            })
            this.metaJobFunctionList = this.orderTagList(jobFunctionList)
          }
        })
      }
      await this.metaJobFunctionListLoader
      return this.metaJobFunctionList
    },
    orderTagList (tagList) {
      if (isEn()) {
        return _.orderBy(tagList, ['name'], ['asc'])
      } else {
        return tagList.sort((a, b) => {
          return a.cn_name.localeCompare(b.cn_name)
        })
      }
    },
    async loadAppliedJobList () {
      const resp = await this.getCompanyGroupedJobList()
      if (resp) {
        const companyJobList = _.map(resp, company => {
          addI18nProperty(company, 'i18nName', 'cn_name', 'name')
          company.job_list = _.map(company.job_list, job => {
            job.cn_title = `${job.id} - ${job.cn_title}`
            job.title = `${job.id} - ${job.title}`
            addI18nProperty(job, 'i18nName', 'cn_title', 'title')
            return job
          })
          return company
        })
        companyJobList.splice(0, 0, createI18nProperty({
          type: 'MY_JOB',
          job_list: [createI18nProperty({ id: 'MY_JOB', type: 'MY_JOB' }, 'i18nName', `${this.i18nPrefix}.label.myJob`)]
        }, 'i18nName', `${this.i18nPrefix}.label.myJob`))
        this.appliedJobList = companyJobList
      }
      return this.appliedJobList
    },
    async loadCompanyPolicyList () {
      const vm = this
      const resp = await this.getCompanyPolicyItemList()
      if (resp) {
        const sortedPolicy = _.orderBy(_.values(resp), ['created_time'], ['desc'])
        const policyList = []
        _.forEach(sortedPolicy, policy => {
          _.forEach(policy.policy_list, policyItem => {
            Object.defineProperty(policyItem, 'i18nName', {
              enumerable: true,
              configurable: true,
              get () {
                const createdTime = moment(policy.created_time).format('YYYY/MM/DD')
                const code = vm.$t(`${vm.i18nPrefix}.label.consentVersionCode`)
                const i18nContent = getI18nPropertyValue(this, 'content_cn', 'content_en')
                const i18nName = `${createdTime} ${code}: ${i18nContent}`
                return i18nName
              }
            })
            const optionList = _.map(CONSENT_STATUS, (val, key) => {
              const option = { value: `${policyItem.id}-${val}` }
              Object.defineProperty(option, 'i18nName', {
                enumerable: true,
                configurable: true,
                get () {
                  return vm.$t(`${vm.i18nPrefix}.consentStatus.${key}`)
                }
              })
              return option
            })
            policyItem.status_list = optionList
            policyList.push(policyItem)
          })
        })
        this.companyPolicyList = policyList
        return this.companyPolicyList
      }
    },
    async loadGroupList (needUnGrouped) {
      const params = { only_talent_pool_group: 1, need_ungrouped: needUnGrouped ? 1 : 0 }
      const resp = await this.getGroupList(params)
      if (resp) {
        const groupList = resp.group_list
        if (needUnGrouped) {
          groupList.splice(0, 0, {
            id: -1,
            text: this.$t(`${this.i18nPrefix}.label.ungrouped`),
            count: resp.ungrouped_candidate_count
          })
        }
        this.groupList = groupList
      }
      return _.sortBy(this.groupList, [(item) => {
        if (item.id === -1) {
          return -1
        } else {
          return _.lowerCase(item.text)
        }
      }])
    },
    async loadCandidateSurveyQuestionList () {
      const resp = await this.getCompanySurveyQuestionList({ survey_type: 'candidate' })
      if (resp) {
        this.candidateSurveyQuestionList = _.map(resp, question => {
          addI18nProperty(question, 'i18nName', 'cn_name', 'name')
          question.answer = _.map(question.answer, answer => {
            addI18nProperty(answer, 'i18nName', 'cn_name', 'name')
            answer.questionId = question.id
            return answer
          })
          return question
        })
        return this.candidateSurveyQuestionList
      }
    },
    async loadEmployeeSurveyQuestionList () {
      const resp = await this.getCompanySurveyQuestionList({ survey_type: 'employee' })
      if (resp) {
        this.employeeSurveyQuestionList = _.map(resp, question => {
          addI18nProperty(question, 'i18nName', 'cn_name', 'name')
          question.answer = _.map(question.answer, answer => {
            addI18nProperty(answer, 'i18nName', 'cn_name', 'name')
            answer.questionId = question.id
            return answer
          })
          return question
        })
        return this.employeeSurveyQuestionList
      }
    },
    async initMajorList () {
      if (this.major.hasLoad) {
        return
      }
      this.major.hasLoad = true
      const resp = await this.getMajorList()
      if (!resp) {
        return
      }
      this.major.data = _.map(resp.majors, major => {
        addI18nProperty(major, 'i18nName', 'cn_name', 'name')
        major.searchTextList = []
        major.searchTextList.push(major.name, major.cn_name)
        return major
      })
      return this.major.data
    },
    async getLocationList () {
      if (this.location.hasLoad) {
        return
      }
      if (this.expectedLocation.hasLoad) {
        this.location = this.expectedLocation
      } else {
        this.location.hasLoad = true
        const resp = await this.getWorldLocationList()
        if (!resp) {
          return
        }
        this.location.data = _.map(resp, location => {
          addI18nProperty(location, 'i18nName', 'cn_name', 'name')
          location.searchTextList = []
          location.searchTextList.push(location.name, location.cn_name, location.pinyin_name)
          if (location.parent_id) {
            const locationInfo = _.find(resp, item => item.id === location.parent_id)
            location.parent = locationInfo
            location.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }

          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === location.id)) {
            location.searchTextList = null
          }
          if (location.type_code === 'region') {
            location.searchTextList = null
          }
          const nameList = []
          if (location.parent) {
            this.getParentLocation(location, nameList)
          }
          const searchLabelList = [location.cn_name]
          if (location.parent) {
            this.getParentLocationCnName(location, searchLabelList)
          }
          location.searchLabelList = _.reverse(searchLabelList)
          location.locationName = _.chain([location.i18nName, ...nameList]).filter().join(' - ').value()
          return location
        })
      }
      return this.location.data
    },
    async getExpectedLocationList () {
      if (this.expectedLocation.hasLoad) {
        return
      }
      if (this.location.hasLoad) {
        this.expectedLocation = this.location
      } else {
        this.expectedLocation.hasLoad = true
        const resp = await this.getWorldLocationList()
        if (!resp) {
          return
        }
        this.expectedLocation.data = _.map(resp, expectedLocation => {
          addI18nProperty(expectedLocation, 'i18nName', 'cn_name', 'name')
          expectedLocation.searchTextList = []
          expectedLocation.searchTextList.push(expectedLocation.name, expectedLocation.cn_name, expectedLocation.pinyin_name)
          if (expectedLocation.parent_id) {
            const locationInfo = _.find(resp, item => item.id === expectedLocation.parent_id)
            expectedLocation.parent = locationInfo
            expectedLocation.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }

          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === expectedLocation.id)) {
            expectedLocation.searchTextList = null
          }
          if (expectedLocation.type_code === 'region') {
            expectedLocation.searchTextList = null
          }
          const nameList = []
          if (expectedLocation.parent) {
            this.getParentLocation(expectedLocation, nameList)
          }
          expectedLocation.locationName = _.chain([expectedLocation.i18nName, ...nameList]).filter().join(' - ').value()
          return expectedLocation
        })
      }
      return this.expectedLocation.data
    },
    async loadLocationList (keywords, loadData, valueList) {
      this.location.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.location.data, location => {
        if (valueList?.length > 0) {
          return _.includes(valueList, location.id)
        } else {
          const keywordsList = _.map(location.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.location.page = 1
      this.location.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.location.pageSize)
    },
    async loadExpectedLocationList (keywords, loadData, valueList) {
      this.expectedLocation.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.expectedLocation.data, expectedLocation => {
        if (valueList?.length > 0) {
          return _.includes(valueList, expectedLocation.id)
        } else {
          const keywordsList = _.map(expectedLocation.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.expectedLocation.page = 1
      this.expectedLocation.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.expectedLocation.pageSize)
    },
    getParentLocation (location, nameList) {
      const parent = location.parent
      if (parent) {
        if (parent.searchTextList) {
          nameList.push(parent.i18nName)
        }
        if (parent.parent_id) {
          this.getParentLocation(parent, nameList)
        }
      }
    },
    getParentLocationCnName (location, nameList) {
      const parent = location.parent
      if (parent) {
        nameList.push(parent.cn_name)
        if (parent.parent_id) {
          this.getParentLocationCnName(parent, nameList)
        }
      }
    },
    async loadLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.location = locationList
      }
    },
    async loadExpectedLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadExpectedLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.expectedLocation = locationList
      }
    },
    async filterLocationMethod (queryValue, filter) {
      let filteredList = []
      _.chain(queryValue).reverse().filter().forEach((query, index) => {
        if (_.isEmpty(filteredList)) {
          filteredList = _.filter(this.location.data, location => {
            return _.includes(location.cn_name, query)
          })
        } else {
          const tempList = _.filter(filteredList, location => {
            let parent = location.parent
            if (index === 2) {
              parent = parent?.parent
            }
            if (parent) {
              return _.chain(parent.searchTextList)
                .map(item => _.toUpper(item))
                .some(item => _.includes(item, _.toUpper(query)))
            }
            return true
          })
          if (!_.isEmpty(tempList)) {
            filteredList = tempList
          }
        }
      }).value()
      return filteredList
    },
    async initSchoolList () {
      if (this.school.hasLoad) {
        return
      }
      this.school.hasLoad = true
      const resp = await this.getSchoolList()
      if (!resp) {
        return
      }
      this.school.data = _.map(resp.schools, school => {
        addI18nProperty(school, 'i18nName', 'cn_name', 'name')
        school.searchTextList = []
        school.searchTextList.push(school.name, school.cn_name, school.pinyin_name)
        return school
      })
      return this.school.data
    },
    async initTagList (tag, category, type, key) {
      if (tag.hasLoad) {
        return
      }
      tag.hasLoad = true
      if (key) {
        await this.loadTagList(category, type, key, true)
        tag.data = this.tagMap[type][key]
      } else {
        await this.loadTagList(category, type)
        tag.data = this.tagMap[type]
      }
      return tag.data
    },
    resetSkillTag (filter) {
      this.skillTag.keywords = null
      this.skillTag.currentData = []
      this.skillTag.page = 1
      if (filter?.option) {
        filter.option.data = []
      }
      return []
    },
    async initSkillTagList () {
      if (!this.skillTag.hasLoad) {
        const skillTagKey = [RESUME_SDK_TAG_KEYS.JOB_SKILL, RESUME_SDK_TAG_KEYS.SOFT_SKILL].join(',')
        this.skillTag.hasLoad = true
        await this.loadTagList('system', RESUME_SDK_TAG_TYPES.SKILLS, skillTagKey, true)
        this.skillTag.data = this.tagMap[RESUME_SDK_TAG_TYPES.SKILLS]?.[skillTagKey] || []
      }
      return this.skillTag.data
    },
    getSkillTagNoDataText () {
      if (!_.trim(this.skillTag.keywords)) {
        return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
      }
      return this.$t('el.select.noMatch')
    },
    getSkillTagSelectAllOptions (filter) {
      if (!_.trim(this.skillTag.keywords) || !filter?.option?.data?.length) {
        return []
      }
      return this.skillTag.currentData || []
    },
    async loadSkillTagList (keywords, valueList) {
      this.skillTag.keywords = keywords
      if (valueList?.length > 0) {
        return this.loadSkillTagSelectedList(valueList)
      }
      if (!_.trim(keywords)) {
        this.skillTag.currentData = []
        this.skillTag.page = 1
        return []
      }
      await this.initSkillTagList()
      return this.searchItemList(this.skillTag, keywords, null, valueList)
    },
    async loadSkillTagSelectedList (valueList) {
      await this.initSkillTagList()
      if (!valueList?.length) {
        return []
      }
      const selectedList = _.filter(this.skillTag.data || [], tag => _.includes(valueList, tag.id))
      this.skillTag.currentData = selectedList
      return selectedList
    },
    async loadSkillTagTemplate (valueList, filter, formattedFilterValues) {
      const selectedList = await this.loadSkillTagSelectedList(valueList)
      filter.option.data = selectedList
      formattedFilterValues.skillTag = selectedList
    },
    async filterSkillTagMethod (value, filter) {
      const selectedList = await this.loadSkillTagSelectedList([value])
      const optionList = _.uniqBy([...(filter.option.data || []), ...selectedList], 'id')
      filter.option.data = optionList
      return optionList
    },
    async initCRMTagList (crmTag) {
      if (!this.hasCRMTagPermission || crmTag.hasLoad) {
        return
      }
      crmTag.hasLoad = true
      const params = {
        is_company_tag: 1,
        need_disabled: 1,
        tag_category: ['manual', 'smart'].join(',')
      }
      const resp = await this.searchTag(params)
      if (resp) {
        const tagList = _.map(resp, tag => {
          const tagInfo = tag
          tag.searchTextList = [tag.name, tag.cn_name]
          addI18nProperty(tagInfo, 'i18nName', 'cn_name', 'name')
          return tagInfo
        })
        crmTag.data = this.orderItemList(tagList)
      }
      return crmTag.data
    },
    orderItemList (tagList) {
      if (isEn()) {
        return _.orderBy(tagList, ['name'], ['asc'])
      } else {
        return tagList.sort((a, b) => {
          return a.cn_name.localeCompare(b.cn_name)
        })
      }
    },
    initSelectData (itemList, page) {
      if (!itemList.data) {
        return []
      }
      itemList.page = page
      itemList.currentData = this.orderItemList(itemList.data)
      return itemList.currentData.slice(0, page * itemList.pageSize)
    },
    async loadLanguageList () {
      const resp = await this.getLanguageList()
      if (resp) {
        this.languageList = _.map(resp.languages, item => addI18nProperty(item, 'i18nName', 'cn_name', 'en_name'))
      }
      return this.languageList
    },
    async loadSchoolList (keywords, loadData, valueList) {
      this.school.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.school.data, school => {
        if (valueList?.length > 0) {
          return _.includes(valueList, school.id)
        } else {
          const keywordsList = _.map(school.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.school.page = 1
      this.school.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.school.pageSize)
    },
    async searchItemList (item, keywords, loadData, valueList) {
      item.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return this.initSelectData(item, 2)
      }
      const itemList = this.orderItemList(item.data)
      const filteredList = _.filter(itemList, item => {
        if (valueList?.length > 0) {
          return _.includes(valueList, item.id)
        } else {
          const keywordsList = _.map(item.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      item.page = 1
      item.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, item.pageSize)
    },
    loadMoreData (item, filter) {
      if (item.currentData && item.page * item.pageSize > item.currentData.length) {
        return
      }
      const data = item.currentData.slice(item.page * item.pageSize, (item.page + 1) * item.pageSize)
      item.page += 1
      filter.option.data.push(...data)
    },
    async loadExportAllInfoFields () {
      if (this.exportInfo.loading) {
        return
      }
      this.exportInfo.loading = true
      const resp = await this.getTalentCandidateExportExcelFieldInfo()
      if (resp) {
        this.exportInfo.data[0].children = _.map(resp, field => {
          addI18nProperty(field, 'i18nName', 'cn_name', 'name')
          _.forEach(field.children, child => {
            addI18nProperty(child, 'i18nName', 'cn_name', 'name')
          })
          return field
        })
      }
      this.exportInfo.loading = false
    },
    async loadSearchTemplateList () {
      const resp = await this.getAccountPageConfigList({ page_type: 'TALENT_POOL_LIST' })
      if (resp) {
        this.searchTemplateList = _.map(resp, pageConfig => {
          return {
            _config: pageConfig,
            id: pageConfig.id,
            name: pageConfig.config.name,
            search: pageConfig.config.search
          }
        })
      }
    },
    async loadTagList (tagCategory, tagType, tagKey, needResumeSDKTag) {
      if (!this.hasCRMTagPermission && !this.hasParseResumeTagPermission) {
        return
      }
      const params = {
        tag_category: tagCategory,
        tag_type: tagType
      }
      if (tagKey) {
        params.tag_key = tagKey
      }
      if (this.hasParseResumeTagPermission && needResumeSDKTag) {
        params.is_common_tag = 1
      } else {
        params.is_company_tag = 1
      }
      const resp = await this.searchTag(params)
      _.forEach(resp, tag => {
        addI18nProperty(tag, 'i18nName', 'cn_name', 'name')
        tag.searchTextList = [tag.name, tag.cn_name]
      })
      if (resp) {
        const tagList = this.orderItemList(resp)
        _.set(this.tagMap, `${tagType}${tagKey ? `.${tagKey}` : ''}`, tagList)
      }
    },
    async loadSalaryList () {
      const resp = await this.getSalaryList()
      if (resp) {
        this.salaryList = resp.salary_list
      }
    },
    async loadIndustryList () {
      const resp = await this.getIndustryList()
      if (resp) {
        const industryList = _.map(resp.industry_list, industry => {
          industry.searchTextList = [industry.cn_name, industry.name]
          addI18nProperty(industry, 'i18nName', 'cn_name', 'name')
          return industry
        })
        this.industryList = this.orderItemList(industryList)
      }
    },
    async loadCandidateStatusList () {
      const resp = await this.getCandidateStatusList({ is_all: 1 })
      if (resp) {
        this.candidateStatusList = _.map(resp, item => addI18nProperty(item, 'i18nName', 'name_cn', 'name_en'))
      }
      return this.candidateStatusList
    },
    async handleCreateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createAccountPageConfig({
          page_type: 'TALENT_POOL_LIST',
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleUpdateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateAccountPageConfig({
          id: template._config.id,
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleClearSearchTemplate () {
      this.searchTemplate = null
    },
    async handleDeleteSearchTemplate (searchTemplate, deletedTemplateIndex) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAccountPageConfig({
          id: searchTemplate.id
        })
        if (resp) {
          this.searchTemplateList.splice(deletedTemplateIndex, 1)
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    getNoDataText (info) {
      if (!info.data || info.data.length === 0) {
        return this.$t('el.select.noData')
      } else if (info.keywords && (!info.currentData || info.currentData.length === 0)) {
        return this.$t('el.select.noMatch')
      }
      return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
    },
    parseSearchToParams (search) {
      const params = { order: `${this.listOrder.order === '-' ? '-' : ''}${this.listOrder.prop}` }
      _.forEach(search, (group, groupKey) => {
        if (_.includes(AI_EXTRA_PARAMS, groupKey)) {
          if (_.isArray(group)) {
            group = _.chain(group).filter().join(',').value()
          }
          params[groupKey] = group
          return
        }
        if (groupKey === 'keywords') {
          params.keywords = group
          return
        }
        if (groupKey === 'candidateName') {
          params.candidate_name = group
          return
        }
        if (groupKey === 'candidateId') {
          params.candidate_id = _.filter(group, item => item && !isNaN(item)).join(',')
          return
        }
        if (groupKey === 'employeeId') {
          params.employee_id = _.filter(group, item => item && item.trim()).join(',')
          return
        }
        const groupFilters = this.filterList[groupKey]
        if (groupFilters?.hidden) {
          return
        }
        const excludeFilterNames = group._exclude
        _.forEach(group, (filterValue, filterName) => {
          const filter = groupFilters?.filterList[filterName]
          if (!filter || !filterValue) {
            return
          }
          filter.setParam(params, filterValue, _.includes(excludeFilterNames, filterName))
        })
      })
      return params
    },
    async handelSearch (search, nextPage, targetPage) {
      if (nextPage) {
        if (this.pagination.page === this.pagination.totalPage) {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.noData`))
          return
        }
        this.pagination.page += 1
      } else {
        this.pagination.page = 1
      }
      this.listLoading = true
      if (!search) {
        search = this.search
      } else {
        this.search = search
      }
      const params = this.parseSearchToParams(search)
      this.searchConfig = this.$refs.filterListRef.formatSearch(search)
      this.searchParams = params
      // if (this.searchedGroupList.length > 0) {
      //   params.groups = JSON.stringify(this.searchedGroupList)
      // }
      const page = targetPage || this.pagination.page
      const candidateList = []
      const promiseList = _.chain(this.pagination.page).range(page + 1)
        .map((val) => {
          return this.getCompanyTalentCandidateList({
            ...params,
            page: val,
            page_size: this.pagination.pageSize
          }).catch(resp => {
            if (resp?.code === 10001010) {
            // 忽略错误: PAGE_NO_RESULT=(10001010, 'That page contains no results'),
              return null
            }
            return Promise.reject(resp)
          })
        }).value()
      const respList = await Promise.all(promiseList)
      let totalPage = this.pagination.totalPage
      let candidateTotalCount = this.candidateTotalCount
      const candidateIdSelectedMap = {}
      _.forEach(this.selectedCandidateList, item => {
        candidateIdSelectedMap[item.candidate.id] = item.selected
      })
      const loadedPages = []
      _.forEach(respList, resp => {
        if (resp) {
          const vm = this
          loadedPages.push(resp.page)
          totalPage = resp.total_page
          candidateTotalCount = resp.total_count
          _.forEach(resp.data, talentInfo => {
            const oldCandidateIsSelected = _.get(candidateIdSelectedMap, talentInfo.candidate.id)
            talentInfo.selected = oldCandidateIsSelected || false
            const candidate = talentInfo.candidate
            candidate.age = candidate.birthday ? moment().diff(candidate.birthday, 'year') : ''
            candidate.name = talentInfo.is_agency_uploaded_and_hid ? this.$t(`${this.i18nPrefix}.label.hidedCandidateName`) : candidate.name
            Object.defineProperty(candidate, 'maxDegreeI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const maxDegree = candidate.max_degree
                // TODO: 学历不存在的时候怎么处理，待确认
                return getConstantI18nValue(DEGREE, maxDegree, 'meta.DEGREE')
              }
            })
            Object.defineProperty(candidate, 'locationInfo', {
              configurable: true,
              enumerable: true,
              get () {
                const location = candidate.location
                if (!location) {
                  return null
                }
                const city = location.city
                const province = location.province
                const country = location.country
                return getI18nPropertyValue(city || province || country, 'cn_name', 'name')
              }
            })
            Object.defineProperty(candidate, 'candidateStatusName', {
              configurable: true,
              enumerable: true,
              get () {
                let i18nKey = null
                if (candidate.is_alumni) {
                  i18nKey = 'alumni'
                } else if (candidate.is_employee) {
                  i18nKey = 'employee'
                } else {
                  i18nKey = 'candidate'
                }
                if (!talentInfo.reviewed) {
                  i18nKey += 'New'
                }
                return vm.$t(`${vm.i18nPrefix}.label.${i18nKey}`)
              }
            })
          })
          candidateList.push(...resp.data)
        }
      })
      if (this.pagination.page === 1) {
        this.candidateList = candidateList
      } else {
        this.candidateList.push(...candidateList)
      }
      this.pagination.page = _.max(loadedPages)
      this.pagination.totalPage = totalPage
      this.candidateTotalCount = candidateTotalCount
      this.listLoading = false
    },
    handleScrollBottom () {
      this.handelSearch(this.search, true)
    },
    handleOrderChange (prop, order) {
      this.listOrder.prop = prop
      this.listOrder.order = order
      this.candidateList = []
      this.handelSearch(this.search, false)
    },
    handleOpenDetail (rowData) {
      const candidateId = rowData.candidate.id
      rowData.reviewed = true
      const params = encodeURIComponent(JSON.stringify(this.parseSearchToParams(this.search)))
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/talent-pool/candidate/profile?candidate_id=${candidateId}&list_params=${params}&back=${backUrl}`)
    },
    openDuplicateCandidateDetail (application) {
      const { candidateId, jobId } = application
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&page_from=duplicate&back=${backUrl}`)
    },
    handleCandidateStatusClick (rowData) {
      this.handleChangeStatusOperation(rowData)
    },
    handleScrollToTop (listType) {
      this.$nextTick(() => {
        const candidateListRef = listType === 'table' ? this.$refs.tableContainer : this.$refs.cardContainer
        candidateListRef.scrollToTop && candidateListRef.scrollToTop()
      })
    },
    reloadListData () {
      this.handelSearch(this.search, false, this.pagination.page)
    },
    async handleTalentPoolAIRecommended () {
      this.aiRecommendedSelectJobDialog.loading = true
      this.aiRecommendedSelectJobDialog.show = true
      try {
        const resp = await this.getCompanyJobList({ all_job: 1, job_type: 2 })
        if (resp) {
          _.forEach(resp.job_list, item => {
            addI18nProperty(item, 'i18nTitle', 'cn_name', 'name')
          })
          this.aiRecommendedSelectJobDialog.jobList = resp.job_list
        }
      } finally {
        this.aiRecommendedSelectJobDialog.loading = false
      }
    },
    handleGenerateAIRecommended (jobId) {
      this.$router.push(`/v-admin/ai-talent-recommendation/job/${jobId}/candidate/`)
    },
    expandChange (expand, groupKey) {
      const accountConfig = this.accountConfig
      _.set(accountConfig, `${TALENT_POOL_PAGE_KEY}.filterConfig.${groupKey}`, expand)
      this.setAccountConfig(accountConfig)
    }
  },
  watch: {
    candidateListLength () {
      if (this.isNoRefreshSelectedCandidateList) {
        return
      }
      if (this.$refs.tableContainer && (this.isSelectedAllCandidate || this.selectAllIsIndeterminate)) {
        this.$refs.tableContainer.refreshSelectAllCandidate()
      }
      if (this.$refs.cardContainer && (this.isSelectedAllCardCandidate || this.selectAllIsIndeterminate)) {
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(this.cancelSelectedCandidateList, candidate) && !candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          } else {
            candidate.selected = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  width: 100%;
  height: 100%;

  .talent-pool-list {
    .last-work {
      margin-top: 6px;
    }

    .filter-label {
      line-height: 20px;
      vertical-align: middle;
    }

    .filter-tip-icon {
      color: #606266;
      margin-left: 4px;
      font-size: 14px;
      line-height: 20px;
      vertical-align: top;
    }
  }

  .rate-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .interview-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .change-candidate-status-dialog {
    ::v-deep {
      .el-dialog__header {
        padding: 34px 40px 0px;
      }

      .el-dialog__body {
        padding: 0px 40px 16px;
      }

      .el-dialog__title {
        font-size: 22px;
        font-weight: 500;
        color: #303133;
      }
    }
  }
}
</style>
<style lang="scss">
.school-popper, .applied-job-popper, .consent-info-popper {
  max-width: 300px;

  .el-select-group__title {
    padding: 0px 20px;
  }

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
